import React from "react";
import { useTranslation } from "react-i18next";

const StepRow = ({ number, title, desc, items, descAfter, optional, isLast }) => {
  const { t } = useTranslation();

  return (
    <div
      className={`flex gap-3 py-3 ${!isLast ? "border-b border-[#E5E5EA] dark:border-[#2C2C2E]" : ""}`}
    >
      <div className="flex-shrink-0 w-8 h-8 rounded-full border border-[#C7C7CC] dark:border-[#48484A] flex items-center justify-center mt-0.5 bg-[#F3F4F6] dark:bg-[#2C2E30]">
        <span className="text-xs font-semibold text-[#636363] dark:text-[#A1A1A1]">
          {number}
        </span>
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-sm font-medium text-[#000000] dark:text-white leading-snug">
          {title}
          {optional && (
            <span className="font-normal text-[#8E8E93]">
              {" "}
              ({t("common.optional")})
            </span>
          )}
        </p>
        {desc && (
          <p className="text-xs lg:text-sm font-normal text-[#636363] dark:text-[#A1A1A1] opacity-80 dark:opacity-60 leading-snug mt-0.5">
            {desc}
          </p>
        )}
        {Array.isArray(items) && items.length > 0 && (
          <ul className="mt-1 space-y-0.5">
            {items.map((item, i) => (
              <li
                key={i}
                className="flex items-start gap-2 text-xs lg:text-sm font-normal text-[#3C3C43] dark:text-[#EBEBF5] opacity-80 dark:opacity-60 leading-snug"
              >
                <span className="flex-shrink-0 mt-[5px] w-1.5 h-1.5 rounded-full bg-[#3C3C43] dark:bg-[#EBEBF5] opacity-60" />
                {item}
              </li>
            ))}
          </ul>
        )}
        {descAfter && (
          <p className="text-xs lg:text-sm font-normal text-[#3C3C43] dark:text-[#EBEBF5] opacity-80 dark:opacity-60 leading-snug mt-1">
            {descAfter}
          </p>
        )}
      </div>
    </div>
  );
};

export default StepRow;
